export const serviceID = process.env.REACT_APP_EMAILJS_SERVICE_ID || '';
export const templateID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID || '';
export const userID = process.env.REACT_APP_EMAILJS_USER_ID || '';
